import { render, staticRenderFns } from "./MaterialEdit.vue?vue&type=template&id=ac98f456&"
import script from "./MaterialEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialEdit.vue?vue&type=script&lang=js&"
import style0 from "./MaterialEdit.vue?vue&type=style&index=0&id=ac98f456&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports